<div class="help-container">
    <div class="questions">
        <p class="doc"> {{ 'register.identity.valid_doc' | translate }} </p>
        <p class="copy">{{ 'register.identity.both' | translate }}</p>
        <p class="color">{{ 'register.identity.color' | translate }}</p>
    </div>
    <h4>{{ 'register.identity.help' | translate }}</h4>
</div>
